<template>
    <div class="container">
        <Error :code="$route.name" :msg="$route.meta.msg"/>
    </div>
</template>  

<script>
import Error from '@/components/error/error.vue'
export default {
    components: {
        Error,
    },
}
</script>